import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const mapBundledServices = (bundles, map)=>bundles.map((bundle)=>_object_spread_props(_object_spread({}, bundle), {
            services: bundle.services.map(map)
        }));
